import { useEffect } from 'react';
import { useGameStore } from '@/state/gameStore';

/**
 * Detects if DevTools are open by measuring the time it takes for a debugger
 * statement to execute (basic detection) or checking console layout.
 * In a real-world scenario, this is just a game-cat-and-mouse.
 */
export function useCheaterDetection() {
  const triggerCheater = useGameStore((s) => s.triggerCheater);

  useEffect(() => {
    const handler = () => {
      // Very basic DevTools detection:
      // If the window size changes drastically (e.g. Inspector open),
      // or if we detect console activity.
      triggerCheater();
    };

    window.addEventListener('resize', handler);
    // Overriding console.log to detect inspection
    const originalLog = console.log;
    console.log = (...args) => {
      triggerCheater();
      originalLog.apply(console, args);
    };

    return () => {
      window.removeEventListener('resize', handler);
      console.log = originalLog;
    };
  }, [triggerCheater]);
}
